import { css } from "@emotion/react";
import { kitText } from "../../styles";

export const styles = {
  tabs: css`
    .bp4-tab-indicator {
      background-color: var(--color-splash-primary);
      height: 0.25rem;
      border-radius: 0.25rem;
      transform: translateY(0.13 rem);
    }
    .bp4-tab {
      color: var(--color-primary);
      font-size: 1rem;
      &:not([aria-disabled="true"]):hover {
        color: var(--color-primary);
      }
    }
  `,
  tabsWrapper: css`
    outline: none;
  `,
  title: css`
    ${kitText.variant.body}
    ${kitText.style.bold}
    margin-bottom: 0.35rem;
  `,
  hasIndicator: css`
    display: flex;
    align-items: center;
    &::before {
      content: "";
      width: 0.375rem;
      height: 0.375rem;
      border-radius: 50%;
      display: inline-block;
      background-color: var(--color-danger);
      box-shadow: 0 0 0.25rem var(--color-danger);
      margin: auto 0.5rem auto 0.125rem;
    }
  `
};
